<template>
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-row :gutter="20">
      <el-col span="8">
        <el-button @click="$parent.onEditorSelectImage(curItem.params, 'imgPath')" class="m-b-20">选择图片</el-button>
        <hot-zone v-if="curItem.params.imgPath"
                  :image="curItem.params.imgPath"
                  :zonesInit="curItem.data"
                  @add="handleAdd"
                  @change="handleChange"
                  @remove="handleRemove"
        />
      </el-col>
      <el-col span="16">
        <div class="param-img-item d-r" :key="index" v-for="(item, index) in curItem.data">
          <div class="url-box1">
            {{ item.title }}
          </div>
          <div class="d-s-c">
            <div class="url-box flex-1">
              <span class="key-name">链接名称：</span>
              <el-input v-model="item.name"></el-input>
            </div>
            <div class="url-box ml10">
              <el-button type="primary" @click="changeLink(index)">选择链接</el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</Setlink>
  </div>
</template>

<script>
import HotZone from '@/components/common/zone/Hotzone'
import Setlink from '@/components/setlink/Setlink'

export default {
  components: {
    HotZone,
    Setlink
  },
  data () {
    return {
      is_linkset: false,
      index: null,
    }
  },
  props: ['curItem', 'selectedIndex', 'opts'],
  created () {
    this.curItem.style.paddingTop = parseInt(this.curItem.style.paddingTop)
  },
  methods: {
    handleAdd (zone) {
      // this.iteminfo.config.datalist[0].zones.push(zone)
      // heightPer:0.5333
      // leftPer:0.4222
      // topPer:0.4667
      // url:""
      // widthPer:0.2139

      let zones = this.curItem.data
      zones.push({
        'topPer': zone.topPer,
        'leftPer': zone.leftPer,
        'widthPer': zone.widthPer,
        'heightPer': zone.heightPer,
        'linkUrl': '',
        'name': '',
        'title': '热区' + (zones.length + 1)
      },)

    },
    handleRemove (index) {
      this.curItem.data.splice(index, 1)
    },
    handleChange () {

    },
    /*选择链接*/
    changeLink (index) {
      this.is_linkset = true
      this.index = index
    },
    /*获取链接并关闭弹窗*/
    closeLinkset (e) {
      this.is_linkset = false
      if (e) {
        this.curItem.data[this.index].linkUrl = e.url
        this.curItem.data[this.index].name = '链接到' + ' ' + e.type + ' ' + e.name
      }
    },
  }
}
</script>

<style>
.diy-notice-icon, .diy-notice-icon img {
  width: 32px;
  height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/HotSpotParam.vue